<header class="relative bg-surface-container-lowest border-b border-outline/50 p-4 flex items-center gap-3">
    <ng-content select="immo-header-left" />
    <div class="grow flex items-center justify-end gap-3">
        <ng-content select="immo-header-navigation" />
        <div class="w-px h-6 bg-outline/50"></div>
        <ng-content select="immo-header-right" />
    </div>
</header>